// src/core/state.js
const state = {
    // Oyun Ayarları
    currentCategory: null,
    currentDifficulty: null,
    isTimedMode: false,
    audioVolume: 0.5,
    isMuted: false,


    // Oyun İlerlemesi
    currentQuestionIndex: 0,
    score: 0,
    correctAnswers: 0,
    wrongAnswers: 0,

    // Soru Havuzu (Aktif oyun için filtrelenmiş)
    activeQuestions: [],

    // Zamanlayıcı
    timer: null,
    timeLeft: 0,

    // Durumu Sıfırla
    reset: function () {
        console.log("[State] Resetting game state...");
        this.currentQuestionIndex = 0;
        this.score = 0;
        this.correctAnswers = 0;
        this.wrongAnswers = 0;
        if (this.timer) clearInterval(this.timer);
    }
};

window.state = state;

